import React, { FC } from 'react';
import classNames from 'classnames';

import { SpecializationDto } from '@apiModels/SpecializationDto.csharp';
import { Button } from '../Partials/Button';
import { List } from '../Partials/List';
import { useInsuranceFilters } from '../Utils/Context/filtersContext';

interface FeaturedSpecializationsProps {
  specializations: SpecializationDto[];
}

export const FeaturedSpecializations: FC<FeaturedSpecializationsProps> = (props) => {
  const { specializations } = props;

  const {
    specialization,
    setSpecialization,
    setService
  } = useInsuranceFilters();

  const handleFeaturedSpecializationClick = (specialization: SpecializationDto) => {
    setSpecialization(specialization);
    setService(null)
  }

  const renderFeaturedSpecializations = (featuredSpecialization: SpecializationDto, index: number) => {
    const isHighlighted = featuredSpecialization.id === specialization?.id;
    return (
      <li key={`feat-spec-${featuredSpecialization.id}-${index}`}>
        <Button
          className="featuredSpecializations__button"
          onClick={() => handleFeaturedSpecializationClick(featuredSpecialization)}
          type="solid"
          tier={isHighlighted ? 'primary' : 'secondary'}
        >
          <span className="featuredSpecializations__name">
            {featuredSpecialization.name}
          </span>
          {featuredSpecialization.insuranceIconUrl && (
            <svg className="featuredSpecializations__icon">
              <image
                className={classNames("featuredSpecializations__iconImage", {
                  "featuredSpecializations__iconImage--highlighted": isHighlighted
                })}
                xlinkHref={featuredSpecialization.insuranceIconUrl}
              />
            </svg>
          )}
        </Button>
      </li>
    )
  }

  return (
    <List
      listClassName='featuredSpecializations'
      items={specializations}
      renderItem={renderFeaturedSpecializations}
      useDefaultLayout={false}
    />
  )
};
